<template>
  <div>
    <el-button @click="downloadPdf">下载合格证pdf</el-button>
    <el-button @click="downloadPdf1">下载水洗唛pdf</el-button>
  </div>
</template>

<script>
const Base64 = require('js-base64').Base64
import { html2pdf } from '../../request/apis';
import { cardHtml } from '../../utils/card2pdf';

export default {
  name: 'TicDownloadPdf',
  data() {
    return {
      apiHost: 'https://gateuat.sgsonline.com.cn',
      btnLoading: false,
      CardData: [{"label":"产品名称","value":"产品名称","required":true},{"label":"商标","value":"商标","required":false},{"label":"号型","value":"共计15种号型 ","required":true},{"label":"款号","value":"111","required":false},{"label":"颜色","value":"111","required":false},{"label":"成分含量","value":"<div>11 10%</div><div>22 90%</div>","required":true},{"label":"产品标准编号","value":"GB/T 2660-2017","required":true},{"label":"产品质量等级","value":"优等品","required":true},{"label":"安全技术要求类别","value":"GB18401-2010  A类","required":true},{"label":"检验合格证明","value":"111","required":true},{"label":"公司名称","value":"111","required":true},{"label":"地址","value":"111","required":true},{"label":"产地","value":"111","required":false}],
      CardName: {"name":"合格证","type":"certificate"},
      SelectTypeSize: {"Size":[{"name":"BabySize","list":[{"modelCode":"100","modelExtendCode":"0","typeId":14,"typeMainCode":"UP","typeSize":"52","typeSubCode":"","typeValue":"52/40"},{"modelCode":"100","modelExtendCode":"0","typeId":15,"typeMainCode":"UP","typeSize":"59","typeSubCode":"","typeValue":"59/40"},{"modelCode":"100","modelExtendCode":"0","typeId":16,"typeMainCode":"UP","typeSize":"59","typeSubCode":"","typeValue":"59/44"},{"modelCode":"100","modelExtendCode":"0","typeId":17,"typeMainCode":"UP","typeSize":"66","typeSubCode":"","typeValue":"66/40"},{"modelCode":"100","modelExtendCode":"0","typeId":18,"typeMainCode":"UP","typeSize":"66","typeSubCode":"","typeValue":"66/44"},{"modelCode":"100","modelExtendCode":"0","typeId":19,"typeMainCode":"UP","typeSize":"66","typeSubCode":"","typeValue":"66/48"},{"modelCode":"100","modelExtendCode":"0","typeId":20,"typeMainCode":"UP","typeSize":"73","typeSubCode":"","typeValue":"73/44"},{"modelCode":"100","modelExtendCode":"0","typeId":21,"typeMainCode":"UP","typeSize":"73","typeSubCode":"","typeValue":"73/48"},{"modelCode":"100","modelExtendCode":"0","typeId":22,"typeMainCode":"UP","typeSize":"80","typeSubCode":"","typeValue":"80/48"},{"modelCode":"100","modelExtendCode":"0","typeId":23,"typeMainCode":"UP","typeSize":"90","typeSubCode":"","typeValue":"90/48"},{"modelCode":"100","modelExtendCode":"0","typeId":24,"typeMainCode":"UP","typeSize":"90","typeSubCode":"","typeValue":"90/52"},{"modelCode":"100","modelExtendCode":"0","typeId":25,"typeMainCode":"UP","typeSize":"90","typeSubCode":"","typeValue":"90/56"},{"modelCode":"100","modelExtendCode":"0","typeId":26,"typeMainCode":"UP","typeSize":"100","typeSubCode":"","typeValue":"100/48"},{"modelCode":"100","modelExtendCode":"0","typeId":27,"typeMainCode":"UP","typeSize":"100","typeSubCode":"","typeValue":"100/52"},{"modelCode":"100","modelExtendCode":"0","typeId":28,"typeMainCode":"UP","typeSize":"100","typeSubCode":"","typeValue":"100/56"}],"checkList":["1"]},{"name":"ChildSize","list":[{"modelCode":"101","modelExtendCode":"0","typeId":44,"typeMainCode":"UP","typeSize":"110","typeSubCode":"","typeValue":"110/52"},{"modelCode":"101","modelExtendCode":"0","typeId":45,"typeMainCode":"UP","typeSize":"110","typeSubCode":"","typeValue":"110/56"},{"modelCode":"101","modelExtendCode":"0","typeId":46,"typeMainCode":"UP","typeSize":"120","typeSubCode":"","typeValue":"120/52"},{"modelCode":"101","modelExtendCode":"0","typeId":47,"typeMainCode":"UP","typeSize":"120","typeSubCode":"","typeValue":"120/56"},{"modelCode":"101","modelExtendCode":"0","typeId":48,"typeMainCode":"UP","typeSize":"120","typeSubCode":"","typeValue":"120/60"},{"modelCode":"101","modelExtendCode":"0","typeId":49,"typeMainCode":"UP","typeSize":"130","typeSubCode":"","typeValue":"130/56"},{"modelCode":"101","modelExtendCode":"0","typeId":50,"typeMainCode":"UP","typeSize":"130","typeSubCode":"","typeValue":"130/60"},{"modelCode":"101","modelExtendCode":"0","typeId":51,"typeMainCode":"UP","typeSize":"130","typeSubCode":"","typeValue":"130/64"}],"checkList":["1"]}],"Ingredients":[{"attrRate":10,"attrValue":"11"},{"attrRate":90,"attrValue":"22"}]},
      CardData1: [
        {
          "label": "号型",
          "value": "110/52 ",
          "required": true
        },
        {
          "label": "成分含量",
          "value": "<div>11d 70%</div><div>22d 10%</div><div>ssd 10%</div><div>323d 10%</div>",
          "required": true
        },
        {
          "label": "洗涤方法",
          "value": [
            {
              "iconName": "水洗符号",
              "iconKey": "ICON.SL_WATER",
              "AllIconList": [
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water1.jpg",
                  "isFill": 0,
                  "configId": 2147,
                  "remark": "不可水洗"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER2",
                  "showSort": 1,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water2.jpg",
                  "isFill": 0,
                  "configId": 2148,
                  "remark": "手洗，最高洗涤温度40℃"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER3",
                  "showSort": 2,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water3.jpg",
                  "isFill": 0,
                  "configId": 2149,
                  "remark": "最高洗涤温度30℃，非常缓和程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER4",
                  "showSort": 3,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water4.jpg",
                  "isFill": 0,
                  "configId": 2150,
                  "remark": "最高洗涤温度30℃，缓和程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER5",
                  "showSort": 4,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water5.jpg",
                  "isFill": 0,
                  "configId": 2151,
                  "remark": "最高洗涤温度30℃，常规程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER6",
                  "showSort": 5,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water6.jpg",
                  "isFill": 0,
                  "configId": 2152,
                  "remark": "最高洗涤温度40℃，非常缓和程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER7",
                  "showSort": 6,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water7.jpg",
                  "isFill": 0,
                  "configId": 2153,
                  "remark": "最高洗涤温度40℃，缓和程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER8",
                  "showSort": 7,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water8.jpg",
                  "isFill": 0,
                  "configId": 2154,
                  "remark": "最高洗涤温度40℃，常规程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER9",
                  "showSort": 8,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water9.jpg",
                  "isFill": 0,
                  "configId": 2155,
                  "remark": "最高洗涤温度50℃，缓和程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER10",
                  "showSort": 9,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water10.jpg",
                  "isFill": 0,
                  "configId": 2156,
                  "remark": "最高洗涤温度50℃，常规程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER11",
                  "showSort": 10,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water11.jpg",
                  "isFill": 0,
                  "configId": 2157,
                  "remark": "最高洗涤温度60℃，缓和程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER12",
                  "showSort": 11,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water12.jpg",
                  "isFill": 0,
                  "configId": 2158,
                  "remark": "最高洗涤温度60℃，常规程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER13",
                  "showSort": 12,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water13.jpg",
                  "isFill": 0,
                  "configId": 2159,
                  "remark": "最高洗涤温度70℃，常规程序"
                },
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER14",
                  "showSort": 13,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water14.jpg",
                  "isFill": 0,
                  "configId": 2160,
                  "remark": "最高洗涤温度95℃，常规程序"
                }
              ],
              "checkIcon": [
                {
                  "colName": "SL_WATER",
                  "tableName": "ICON",
                  "enumCode": "WATER2",
                  "showSort": 1,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/water/water2.jpg",
                  "isFill": 0,
                  "configId": 2148,
                  "remark": "手洗，最高洗涤温度40℃"
                }
              ],
              "CheckShow": false,
              "multiple": false
            },
            {
              "iconName": "漂白符号",
              "iconKey": "ICON.SL_BLEACH",
              "AllIconList": [
                {
                  "colName": "SL_BLEACH",
                  "tableName": "ICON",
                  "enumCode": "BLEACH1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/bleach/bleach1.JPG",
                  "isFill": 0,
                  "configId": 2161,
                  "remark": "允许任何漂白剂"
                },
                {
                  "colName": "SL_BLEACH",
                  "tableName": "ICON",
                  "enumCode": "BLEACH2",
                  "showSort": 1,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/bleach/bleach2.JPG",
                  "isFill": 0,
                  "configId": 2162,
                  "remark": "不可漂白"
                },
                {
                  "colName": "SL_BLEACH",
                  "tableName": "ICON",
                  "enumCode": "BLEACH3",
                  "showSort": 2,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/bleach/bleach3.JPG",
                  "isFill": 0,
                  "configId": 2163,
                  "remark": "仅允许氧漂/非氯漂"
                }
              ],
              "checkIcon": [
                {
                  "colName": "SL_BLEACH",
                  "tableName": "ICON",
                  "enumCode": "BLEACH1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/bleach/bleach1.JPG",
                  "isFill": 0,
                  "configId": 2161,
                  "remark": "允许任何漂白剂"
                }
              ],
              "CheckShow": false,
              "multiple": false
            },
            {
              "iconName": "干燥符号",
              "iconKey": "ICON.SL_DRY",
              "AllIconList": [
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry1.jpg",
                  "isFill": 1,
                  "configId": 2164,
                  "remark": "不可翻转干燥"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY2",
                  "showSort": 1,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry2.JPG",
                  "isFill": 1,
                  "configId": 2165,
                  "remark": "可使用翻转干燥，常规温度，排气口最高温度80℃"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY3",
                  "showSort": 2,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry3.JPG",
                  "isFill": 1,
                  "configId": 2166,
                  "remark": "可使用翻转干燥，较低温度，排气口最高温度60℃"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY4",
                  "showSort": 3,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry4.JPG",
                  "isFill": 1,
                  "configId": 2167,
                  "remark": "悬挂晾干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY5",
                  "showSort": 4,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry5.JPG",
                  "isFill": 1,
                  "configId": 2168,
                  "remark": "悬挂滴干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY6",
                  "showSort": 5,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry6.JPG",
                  "isFill": 1,
                  "configId": 2169,
                  "remark": "在阴凉处悬挂晾干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY7",
                  "showSort": 6,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry7.JPG",
                  "isFill": 1,
                  "configId": 2170,
                  "remark": "在阴凉处悬挂滴干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY8",
                  "showSort": 7,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry8.JPG",
                  "isFill": 1,
                  "configId": 2171,
                  "remark": "平摊晾干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY9",
                  "showSort": 8,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry9.JPG",
                  "isFill": 1,
                  "configId": 2172,
                  "remark": "平摊滴干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY10",
                  "showSort": 9,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry10.JPG",
                  "isFill": 1,
                  "configId": 2173,
                  "remark": "在阴凉处平摊晾干"
                },
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY11",
                  "showSort": 10,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry11.JPG",
                  "isFill": 1,
                  "configId": 2174,
                  "remark": "在阴凉处平摊滴干"
                }
              ],
              "checkIcon": [
                {
                  "colName": "SL_DRY",
                  "tableName": "ICON",
                  "enumCode": "DRY1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry/dry1.jpg",
                  "isFill": 1,
                  "configId": 2164,
                  "remark": "不可翻转干燥"
                }
              ],
              "CheckShow": false,
              "multiple": true
            },
            {
              "iconName": "熨烫符号",
              "iconKey": "ICON.SL_IRONING",
              "AllIconList": [
                {
                  "colName": "SL_IRONING",
                  "tableName": "ICON",
                  "enumCode": "IRONING1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/ironing/ironing1.jpg",
                  "isFill": 0,
                  "configId": 2175,
                  "remark": "熨斗底板最高温度200℃"
                },
                {
                  "colName": "SL_IRONING",
                  "tableName": "ICON",
                  "enumCode": "IRONING2",
                  "showSort": 1,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/ironing/ironing2.jpg",
                  "isFill": 0,
                  "configId": 2176,
                  "remark": "熨斗底板最高温度150℃"
                },
                {
                  "colName": "SL_IRONING",
                  "tableName": "ICON",
                  "enumCode": "IRONING3",
                  "showSort": 2,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/ironing/ironing3.jpg",
                  "isFill": 0,
                  "configId": 2177,
                  "remark": "熨斗底板最高温度110℃，蒸汽熨烫可能造成不可回复的损伤"
                },
                {
                  "colName": "SL_IRONING",
                  "tableName": "ICON",
                  "enumCode": "IRONING4",
                  "showSort": 3,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/ironing/ironing4.jpg",
                  "isFill": 0,
                  "configId": 2178,
                  "remark": "不可熨烫"
                }
              ],
              "checkIcon": [
                {
                  "colName": "SL_IRONING",
                  "tableName": "ICON",
                  "enumCode": "IRONING1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/ironing/ironing1.jpg",
                  "isFill": 0,
                  "configId": 2175,
                  "remark": "熨斗底板最高温度200℃"
                }
              ],
              "CheckShow": false,
              "multiple": false
            },
            {
              "iconName": "干洗符号",
              "iconKey": "ICON.SL_DRY_CLEAN",
              "AllIconList": [
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean1.jpg",
                  "isFill": 1,
                  "configId": 2179,
                  "remark": "使用四氯乙烯和符号F代表的所有溶剂的专业干洗，常规干洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN2",
                  "showSort": 1,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean2.jpg",
                  "isFill": 1,
                  "configId": 2180,
                  "remark": "使用碳氢化合物溶剂的专业干洗，常规干洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN3",
                  "showSort": 2,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean3.jpg",
                  "isFill": 1,
                  "configId": 2181,
                  "remark": "专业湿洗，常规湿洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN4",
                  "showSort": 3,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean4.jpg",
                  "isFill": 1,
                  "configId": 2182,
                  "remark": "不可干洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN5",
                  "showSort": 4,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean5.jpg",
                  "isFill": 1,
                  "configId": 2183,
                  "remark": "使用四氯乙烯和符号F代表的所有溶剂的专业干洗，缓和干洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN6",
                  "showSort": 5,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean6.jpg",
                  "isFill": 1,
                  "configId": 2184,
                  "remark": "使用碳氢化合物溶剂的专业干洗，缓和干洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN7",
                  "showSort": 6,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean7.jpg",
                  "isFill": 1,
                  "configId": 2185,
                  "remark": "专业湿洗，缓和湿洗"
                },
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN8",
                  "showSort": 7,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean8.jpg",
                  "isFill": 1,
                  "configId": 2186,
                  "remark": "专业湿洗，非常缓和湿洗"
                }
              ],
              "checkIcon": [
                {
                  "colName": "SL_DRY_CLEAN",
                  "tableName": "ICON",
                  "enumCode": "DRY_CLEAN1",
                  "showSort": 0,
                  "enumName": "https://cnstatic.sgsonline.com.cn/public/tic/icon/dry_clean/dry_clean1.jpg",
                  "isFill": 1,
                  "configId": 2179,
                  "remark": "使用四氯乙烯和符号F代表的所有溶剂的专业干洗，常规干洗"
                }
              ],
              "CheckShow": false,
              "multiple": true
            }
          ],
          "typeImg": true,
          "required": true
        },
        {
          "label": "洗涤提醒",
          "value": "drtfguhij",
          "required": false
        }
      ],
      CardName1: {"name":"水洗唛","type":"Washcertificate"}

    }
  },
  methods: {
    downloadPdf() {
      html2pdf({
        fileContent: Base64.encode(cardHtml(this.SelectTypeSize, this.CardData, this.CardName.name)),
      }, `${this.CardName.name}.pdf`, this.apiHost, this, 'btnLoading')
    },
    downloadPdf1() {
      html2pdf({
        fileContent: Base64.encode(cardHtml(this.SelectTypeSize, this.CardData1, this.CardName1.name)),
      }, `${this.CardName1.name}.pdf`, this.apiHost, this, 'btnLoading')
    }
  }
};
</script>

<style scoped>

</style>
